import React, { memo, useCallback, useState, Fragment, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _cloneDeep from 'lodash/cloneDeep';
import _isEqual from 'lodash/isEqual';
import moment from 'moment';

import {
  Checkbox,
  ShowItemsSelectPageCount,
  Message,
  Pagination,
  OverestimationModal,
  ToFormRegisterModal,
  ToFormWithdrawalInventoryModal,
} from '../../utilites';
import { ActionButton, ConfirmModal, AlertModal } from '../../common';
import {
  pageOptions,
  contractStatuses,
  viewDocument,
  viewReports,
} from '../../../helpers/data-constants';
import {filtersSelectedDeals, permissionsAccess, useQuery, validateDelayDays} from '../../../helpers/common';
import {
  getInventories,
  getInventoryDeals,
  getDealsForTransfer,
  transferSaled,
  changeContractStatuses,
  overestimationDeals,
  transferDeals,
  getPrintedForm,
  changeContractStatusesRefund,
} from '../../../redux/actions/contractAction';
import { getListUsers } from '../../../redux/actions/userAction';
import TNStoreDetails from './TNStoreDetails/TNStoreDetails';
import Loader from './Loader/Loader';
import TransferSaledModal from '../../utilites/modal/TransferSaledModal/TransferSaledModal';

import './tnStore.scss';

import Arrow from '../../../assets/icons/arrow-down.svg';
import { useHistory } from 'react-router-dom';
import ReturnOfUnclaimedGoodsLayout from "./ReturnOfUnclaimedGoods/ReturnOfUnclaimedGoodsLayout";
import {messages} from "../../../helpers/messages";
import ModalInboxOperation from "../../Reports/modals/ModalInboxOperation/ModalInboxOperation";
import {SESSION_BY_ID} from "../../../constants/token";
import BasicAlert from "../../utilites/Alert/Alert";


const initialState = {
  currentPage: 1,
  pageRange: pageOptions[0].value,
  reqId: null,
  reqParamTN: [],
  isTransferdSaledStore: false,
  isToTransfer: false,
  isToStore: false,
  isOverestimation: false,
  isTransferAnotherStore: false,
  isInventory: false,
  permissibleDate: null,
  isInboxOperation: false
};

const fields = ["revaluationDays", "id", "dealNumber", "positions", "totalToPay", "totalEstimatedValue", "positions.positionId", "positions.names", "positions.quantity", "positions.estimatedValue", "amount", "refundAmount", "accruedInterest"]

const TNStore = memo(({
                        dealStatus,
                        cashBoxInfo,
                        dataActiveCashbox,
                        setError,
                        stateSearch

}) => {
  const {cashBoxIds, fullName, dealNumber, typeDeal, delaysDay, typeDuration} = stateSearch
  const {
    inventoriesData: { inventories, total },
    isLoading,
    commonError,
    isTabLoading,
    inventory,
    dealsForTransfer,
    modalError,
    isModalLoading,
    changeContract,
    dealSuccess
  } = useSelector(({ contract }) => contract);

  const { listUsers, isLoading: userLoading, accessFeatures } = useSelector(({ user }) => user);
  const dispatch = useDispatch();

  const [requestCurrentState, setRequestCurrentState] = useState(false);
  const [stateOverestimationDeals, setStateOverestimationDeals] = useState([]);
  const [isOverestimationTransfer, setIsOverestimationTransfer] = useState(false);
  const [state, setState] = useState(initialState);
  const [allChecked, setAllChecked] = useState(false);
  const [TN, setTN] = useState([]);
  const [selectedDeals, setSelectedDeals] = useState([]);
  const [refundThings, setRefundThings] = useState(false)
  const [errorModalState, setErrorModalState] = useState({
    state: false,
    message: ''
  })
  const [popup, setPopup] = useState({
    isOpen: false,
    type: 'error',
    header: 'Ошибка',
    text: 'Ошибка',
  });
  const notEmpty = TN && TN.length !== 0;
  const store = dealStatus === contractStatuses.STORE.param;
  const saledStore = dealStatus === contractStatuses.SALED_STORE.param;
  const userCashBox = JSON.parse(localStorage.getItem(SESSION_BY_ID))

  const history = useHistory()
  const query = useQuery()
  const queryPageRange = query.get('pageRange')
  const queryPage = query.get('page')
  const queryStatus = query.get('dealStatus')

  useEffect(() => {
    setState((prev) => ({
      ...prev,
      currentPage: 1,
    }))
  }, [cashBoxIds, dealNumber, typeDeal, fullName, delaysDay, typeDuration])

  useEffect(() => {
    setAllChecked(false);
    return () => {
      setState((prev) => ({
        ...prev,
        currentPage: 1,
        pageRange: pageOptions[0].value,
      }));
    };
  }, [dealStatus]);

  useEffect(() => {
    if(queryStatus === dealStatus) {
      let actualPageRange = state.pageRange;
      let actualPage = state.currentPage;

      if (!!queryPageRange) actualPageRange = +queryPageRange;
      if (!!queryPage) actualPage = +queryPage;
      setState((prev) => ({
        ...prev,
        currentPage: actualPage,
        pageRange: actualPageRange,
      }));
    }
  }, []);

  useEffect(() => {
    history.push({
      search: `?dealStatus=${dealStatus}&pageRange=${state.pageRange}&page=${state.currentPage}`
    })
  }, [dealStatus, state.pageRange, state.currentPage])

  useEffect(() => {
    const availableDepartaments = JSON.parse(localStorage.getItem('AVAILABLE_DEPARTMENTS'))
    const transferIds = []
    for (let i = 0; i < dealNumber.length; i++) {
      if (!dealNumber[i].transferId) {
        transferIds.push(dealNumber[i].value)
      } else {
        transferIds.push(dealNumber[i].transferId)
      }
    }

    const validationResult = validateDelayDays(delaysDay);

    if (validationResult) {
      setError(validationResult);
      return;
    } else {
      setError('')
    }

    if (store) {
      dispatch(
        getInventories(
          state.pageRange,
          transferIds.length ? 1 : state.currentPage,
          contractStatuses.STORE.param,
          true,
          'transferDate',
          contractStatuses.STORE.param,
            permissionsAccess("expired.branch_director.search") && cashBoxIds.length === 0
                ? availableDepartaments.join(',')
                : cashBoxIds.map((i) => i.value).join(','),
          typeDuration.map(i => i.value).join(','),
          fullName.map(i => i.value).join(','),
          transferIds.join(','),
          typeDeal.map(i => i.value).join(','),
          delaysDay.from,
          delaysDay.to,
        ),
      );
    }
    if (saledStore) {
      dispatch(
        getInventories(
          state.pageRange,
          transferIds.length ? 1 : state.currentPage,
          contractStatuses.STORE.param,
          true,
          'transferDate',
          contractStatuses.SALED_STORE.param,
            permissionsAccess("expired.branch_director.search") && cashBoxIds.length === 0
                ? availableDepartaments.join(',')
                : cashBoxIds.map((i) => i.value).join(','),
          typeDuration.map(i => i.value).join(','),
          fullName.map(i => i.value).join(','),
          transferIds.join(','),
          typeDeal.map(i => i.value).join(','),
          delaysDay.from,
          delaysDay.to,
        ),
      );
    }
    setRequestCurrentState(false)
  }, [
    state.pageRange,
    state.currentPage,
    dispatch,
    dealStatus,
    changeContract,
    saledStore,
    store,
    cashBoxIds,
    fullName,
    dealNumber,
    typeDeal,
    delaysDay,
    typeDuration
  ]);

  useEffect(() => {
    if (inventories.length !== 0) {
      const listUsers = [...new Set(inventories.map(({ userId }) => userId))].join(',');
      dispatch(getListUsers(listUsers));
    }
  }, [inventories, dispatch]);

  useEffect(() => {
    if (inventories && inventories.length !== 0 && listUsers && listUsers.length !== 0) {
      const formattedTN = inventories.map((i) => {
        i.checked = false;
        i.isVisible = false;
        i.userFullName = listUsers.find((user) => user.id === i.userId)
          ? listUsers.find((user) => user.id === i.userId).fullName
          : null;
        return i;
      });
      setState((prev) => ({
        ...prev,
        reqParamTN: formattedTN.map(({ transferId }) => ({
          transferId,
          size: 1000,
          page: 1,
          isTabLoading: false,
        })),
      }));
      setTN(formattedTN);
    } else {
      setTN([]);
    }
  }, [inventories, listUsers]);

  useEffect(() => {
    if (
      TN &&
      TN.length !== 0 &&
      inventories &&
      inventories.length !== 0 &&
      !_isEqual(inventory, {}) &&
      inventory.deal.length !== 0
    ) {
      const dataInventory = _cloneDeep(TN.find(({ transferId }) => transferId === state.reqId));
      dataInventory.deal = {
        ...inventory,
        deal: inventory.deal.map((i) => {
          i.checked = dataInventory.hasOwnProperty('checked') ? dataInventory.checked : allChecked;
          return i;
        }),
      };

      const ind = TN.findIndex(({ transferId }) => transferId === state.reqId);
      setTN((prev) => [...prev.slice(0, ind), dataInventory, ...prev.slice(ind + 1)]);

      const newReqParam = {
        ...state.reqParamTN.find(({ transferId }) => transferId === state.reqId),
      };
      newReqParam.isTabLoading = false;
      const indx = state.reqParamTN.findIndex(({ transferId }) => transferId === state.reqId);
      setState((prev) => ({
        ...prev,
        reqParamTN: [
          ...prev.reqParamTN.slice(0, indx),
          newReqParam,
          ...prev.reqParamTN.slice(indx + 1),
        ],
      }));
    }
  }, [inventory]);

  useEffect(() => {
    if (notEmpty) {
      const TNChecked = TN.filter((i) => {
        const arrDeal = TN.filter((i) => i?.deal);
        if (arrDeal.length !== 0) {
          if (i.deal?.deal && i.deal.deal.length !== 0) {
            return i.deal.deal.filter((item) => item.checked).length !== 0 || i.checked;
          } else {
            return i.checked;
          }
        } else {
          return i.checked;
        }
      });

      if (TNChecked.length !== 0 && TN.filter((i) => i?.deal).length !== 0) {
        const TNDealChecked = TNChecked.map((i) => {
          if (i?.deal && i.deal.deal.length !== 0) {
            if (i.deal.deal.filter((item) => item.checked).length !== 0) {
              return {
                ...i,
                deal: {
                  ...i.deal,
                  deal: i.deal.deal.filter((item) => item.checked),
                },
              };
            } else {
              return { ...i, deal: null };
            }
          } else {
            return i;
          }
        });
        setSelectedDeals(TNDealChecked);
      } else {
        setSelectedDeals(TNChecked.length ? TNChecked : selectedDeals);
      }
    }
  }, [TN, notEmpty]);

  useEffect(() => {
    if (commonError && state.reqParamTN.length !== 0) {
      setState((prev) => ({
        ...prev,
        reqParamTN: prev.reqParamTN.map((i) => ({ ...i, isTabLoading: false })),
      }));
    }
  }, [commonError]);

  useEffect(() => {
    if (dealSuccess && dealStatus === contractStatuses.STORE.param) {
      requestDealForTransfer()
    }
  }, [dealSuccess])

  const checkBoxAfterOperation = () => {
    const newArray = _cloneDeep(TN);

    const updatedArray = newArray.map((el) => {
      if (el.deal && el.deal.deal) {
        const updatedDeal = el.deal.deal.map((contract) => ({
          ...contract,
          checked: false,
        }));

        return {
          ...el,
          checked: false,
          deal: {
            ...el.deal,
            deal: updatedDeal,
          },
        };
      } else {
        return {...el, checked: false };
      }
    });
    setTN(updatedArray);
  }

  const onPageRangeChange = useCallback((value) => {
    setState((prev) => ({
      ...prev,
      pageRange: parseInt(value),
      currentPage: 1,
    }));
    setAllChecked(false);
  }, []);

  const handlePageChange = useCallback((page) => {
    setState((prev) => ({
      ...prev,
      currentPage: page,
    }));
    setAllChecked(false);
  }, []);

  const handleAllContractCheck = useCallback(() => {
    if (notEmpty) {
      const arrDeal = TN.filter((i) => i?.deal);
      if (arrDeal.length !== 0) {
        setTN((prev) =>
          prev.map((item) => {
            if (item?.deal) {
              return {
                ...item,
                checked: !allChecked,
                deal: {
                  ...item.deal,
                  deal: item.deal.deal.map((i) => ({
                    ...i,
                    checked: !allChecked,
                  })),
                },
              };
            } else {
              return {
                ...item,
                checked: !allChecked,
              };
            }
          }),
        );
      } else {
        setTN((prev) =>
          prev.map((item) => ({
            ...item,
            checked: !allChecked,
          })),
        );
      }

      setAllChecked(!allChecked);
    }
  }, [allChecked, TN, notEmpty]);

  const handleTNCheck = useCallback(
    (e) => {
      if (accessFeatures['deals.refund_things'] && saledStore) {
        setErrorModalState({state: true, message: "Необходимо выбрать договор"})
        return
      }
      if (notEmpty) {
        const id = TN.findIndex((item) => item.transferId + item.transferDate === e.target.id);
        const newArray = _cloneDeep(TN);
        newArray[id].checked = !TN[id].checked;

        if (newArray[id].deal?.deal) {
          newArray[id].deal.deal = TN[id].deal.deal.map((i) => ({
            ...i,
            checked: !TN[id].checked,
          }));
        }

        setTN(newArray);
      }
    },
    [TN, notEmpty],
  );

  const handleContractCheck = useCallback(
    (e, transferId) => {
      let tnId = TN.findIndex((item) => item.transferId === transferId);
      let contractId = TN[tnId].deal.deal.findIndex((i) => i.id === +e.target.id);
      let newArray = _cloneDeep(TN);
      newArray[tnId].deal.deal[contractId].checked = !TN[tnId].deal.deal[contractId].checked;
      setTN(newArray);
    },
    [TN],
  );

  const changeVisible = (id) => {
    let ind = TN.findIndex((item) => item.transferId === id);
    let newArray = _cloneDeep(TN);
    newArray[ind].isVisible = !TN[ind].isVisible;
    setTN(newArray);

    const newReqParam = { ...state.reqParamTN.find(({ transferId }) => transferId === id) };
    const indx = state.reqParamTN.findIndex(({ transferId }) => transferId === id);
    const { page, size } = newReqParam;

    if (newArray[ind].isVisible) {
      newReqParam.isTabLoading = true;
      setState((prev) => ({
        ...prev,
        reqId: id,
        reqParamTN: [
          ...prev.reqParamTN.slice(0, indx),
          newReqParam,
          ...prev.reqParamTN.slice(indx + 1),
        ],
      }));
    } else {
      newReqParam.isTabLoading = false;
      setState((prev) => ({
        ...prev,
        reqId: id,
        reqParamTN: [
          ...prev.reqParamTN.slice(0, indx),
          newReqParam,
          ...prev.reqParamTN.slice(indx + 1),
        ],
      }));
    }

    if (store && newArray[ind].isVisible) {
      dispatch(getInventoryDeals(size, page, id, contractStatuses.STORE.param, false));
    }

    if (saledStore && newArray[ind].isVisible) {
      dispatch(getInventoryDeals(size, page, id, contractStatuses.SALED_STORE.param, false));
    }
  };

  function requestDealForTransfer(){
    const data = filtersSelectedDeals(selectedDeals);
    const dealIds = data.dealIds.length ? data.dealIds.join(',') : '';
    const transferId = data.transferIds.length ? data.transferIds.join(',') : '';

    const payload = {
      size: 1000,
      page: 1,
      descending: false,
      filters: {
        status: dealStatus
      },
      orFilters: {
        dealIds,
        transferId
      },
      fields
    }

    dispatch(
        getDealsForTransfer(payload),
    );
  }

  const openModal = useCallback(
    (view) => {
      if (selectedDeals.length) {
        if (view === viewDocument.isTransferdSaledStore || view === viewDocument.isOverestimation) {
          requestDealForTransfer();
        }

        if (view === viewDocument.isInventory) {
          return setState((prev) => ({
            ...prev,
            [view]: true,
            permissibleDate: selectedDeals.reduce(
              (p, c) => moment(p).min(c.transferDate).format('YYYY-MM-DD'),
              selectedDeals[0].transferDate,
            ),
          }));
        }
        if (view === viewDocument.isToStore && accessFeatures['deals.refund_things']) {
          const oneDeal = selectedDeals.length ===1 && selectedDeals[0].deal?.deal && selectedDeals[0].deal?.deal.length === 1;
          const endDate = selectedDeals[0].deal?.deal[0].endDate
          const today = moment()
          const validDate = today.diff(endDate, "days") < 60

            if (!oneDeal) {
              setPopup((prev) => ({
                ...prev,
                isOpen: true,
                text: messages[16012],
              }));
              return;
            }
            if (!validDate) {
              setPopup((prev) => ({
                ...prev,
                isOpen: true,
                text: messages[16013],
              }));
              return;
            }
        }

        setState((prev) => ({ ...prev, [view]: true }));
      }
    },
    [selectedDeals, dispatch, dealStatus],
  );

  const handleCloseModal = useCallback((view) => {
    setState((prev) => ({ ...prev, [view]: false, permissibleDate: null }));
  }, []);

  const submitTransferSaledStore = useCallback((cash, deposit) => {
    handleCloseModal(viewDocument.isTransferdSaledStore);
    const feature = accessFeatures['report.inventory_sale_invoice']
    const newDeposit = {
      cash: +deposit.cash || 0,
      nonCash: +deposit.nonCash || 0,
      bankTransaction: +deposit.bankTransaction || 0
    }

    const { dealIds, transferIds } = filtersSelectedDeals(selectedDeals);

    if (selectedDeals.length === TN.length && state.currentPage > 1) {
      setState((prev) => ({ ...prev, currentPage: prev.currentPage - 1 }));
    }

    const cashBoxId = dataActiveCashbox.current.value;

    const data = {
      transferIds,
      status: dealStatus,
      data: undefined,
      cash,
      cashBoxId,
      getJsonFile: false,
      feature,
      deposit: newDeposit
    }

      if (stateOverestimationDeals && stateOverestimationDeals.length > 0) {
      const dealsIds = [];

      for (let i = 0; i < stateOverestimationDeals.length; i++) {
          const { dealIds } = stateOverestimationDeals[i];
          dealsIds.push(+dealIds);
      }

      dispatch(transferSaled({...data, dealIds: dealsIds}));
      setStateOverestimationDeals([])
    } else {
      dispatch(transferSaled({...data, dealIds: dealIds}));
    }

    setAllChecked(false);
  }, [dealStatus, dispatch, handleCloseModal, selectedDeals, TN.length, state.currentPage]);

  const addToTransferAndOnTransactionSubmit = (entity) => {
    handleCloseModal('isInboxOperation')
    const dealIds = selectedDeals[0] && selectedDeals[0].deal?.deal[0].id
    let data = {
      dealIds: [dealIds],
      newStatus: contractStatuses.STORE.param,
      transfersStatus: dealStatus,
      type: 'DEBIT',
      section: entity.section.value,
      cashAmount: entity.amount,
      date: entity.date,
      documentNumber: entity.documentNumber,
      description: entity.description,
      accepted: entity.accepted.label,
      additionalInfo: entity.attachment,
      passport: entity.passport
    }
    dispatch(changeContractStatusesRefund(data, userCashBox.value))
  }
  const addToTransfer = useCallback(() => {
    store && handleCloseModal(viewDocument.isToTransfer);
    saledStore && handleCloseModal(viewDocument.isToStore);
    const dealInfo = selectedDeals[0] && selectedDeals[0].deal?.deal[0]

    const { dealIds, transferIds } = filtersSelectedDeals(selectedDeals);

    if (selectedDeals.length === TN.length && state.currentPage > 1) {
      setState((prev) => ({ ...prev, currentPage: prev.currentPage - 1 }));
    }

    if (store) {
      dispatch(
        changeContractStatuses(dealIds, contractStatuses.TOTRANSFER.param, transferIds, dealStatus),
      );
    }

    if (saledStore) {
      if (accessFeatures['deals.refund_things'] && dealInfo.cash !== 0) {
        openModal('isInboxOperation')
        setRefundThings(true)
      }
    else {
        dispatch(
          changeContractStatuses(dealIds, contractStatuses.STORE.param, transferIds, dealStatus, accessFeatures['deals.refund_things'], userCashBox.value)
        );
    }
    }

    setAllChecked(false);
  }, [
    handleCloseModal,
    dispatch,
    selectedDeals,
    state.currentPage,
    TN.length,
    dealStatus,
    saledStore,
    store,
  ]);

  const closeConfirm = useCallback(() => {
    store && handleCloseModal(viewDocument.isToTransfer);
    saledStore && handleCloseModal(viewDocument.isToStore);
  }, [handleCloseModal, store, saledStore]);

  const submitOverestimation = (data) => {
    const filteredData = {
      ...data,
      dealsIds: data.dealsIds.filter(item => item.totalEstimatedValue !== item.estimatedValue)
    };

    if (!filteredData.dealsIds.length) {
      setIsOverestimationTransfer(false);
      return
    }

    let bodyReport = null;
    const reqBodyOverestimation = {
      dealsIds: filteredData.dealsIds.map(({ dealId, estimatedValue }) => ({
        dealId,
        estimatedValue,
      })),
      base: filteredData?.base ? filteredData.base : '',
    };
    const markdownDeals = filteredData.dealsIds.filter((i) => i.estimatedValue < i.totalEstimatedValue);
    const dealIds = markdownDeals.map(({ dealId }) => dealId).join(',');
    if (markdownDeals.length) {
      const filename =
        'exp_' +
        (filteredData.documentNumber ? filteredData.documentNumber : dealIds) +
        '_' +
        moment().format('DD.MM.YYYY') +
        '_.pdf';

      bodyReport = {
        reqBodyReport: {
          cashBoxId: cashBoxInfo.id,
          dealIds,
          documentNumber: filteredData?.documentNumber ? filteredData.documentNumber : 'б/н'
        },
        filename,
        viewReport: viewReports.MARKDOWN_ACT,
      };
    }

    setStateOverestimationDeals(
        dealsForTransfer.map(el => ({
            dealIds: el.id, estimatedValue: el.totalEstimatedValue, totalEstimatedValue: el.totalEstimatedValue
        })))

    if (selectedDeals.length === TN.length && state.currentPage > 1) {
      setState((prev) => ({ ...prev, currentPage: prev.currentPage - 1 }));
    }

    dispatch(overestimationDeals(reqBodyOverestimation, bodyReport, true));

    setIsOverestimationTransfer(false);
    setStateOverestimationDeals([])
    handleCloseModal(viewDocument.isOverestimation);
  };

  const submitTransferAnotherStore = useCallback(
    (data) => {
      const { dealIds, transferIds } = filtersSelectedDeals(selectedDeals);
      const filename = 'exp_' + data.documentNumber + '_' + data.transferDate + '.pdf';
      data.dealIds = dealIds;
      data.transferIds = transferIds;
     const viewReport = viewReports.MOVEMENT_STORE;

      if (selectedDeals.length === TN.length && state.currentPage > 1) {
        setState((prev) => ({ ...prev, currentPage: prev.currentPage - 1 }));
      }

      dispatch(transferDeals(data, viewReport, state.isTransferAnotherStore, { pdf: filename }));
      setAllChecked(false);
    },
    [dispatch, selectedDeals, TN.length, state.currentPage, state.isTransferAnotherStore],
  );

  const submitTransferInventory = (data) => {
    const filenamePdf = 'exp_' + data.documentNumber + '_' + data.transferDate + '.pdf';
    const filenameXlsx = 'exp_' + data.documentNumber + '_' + data.transferDate + '.xlsx';
    const { dealIds, transferIds } = filtersSelectedDeals(selectedDeals);
    const viewReport = viewReports.INVENTORY_FROM_STORE;
    data.dealIds = dealIds;
    data.transferIds = transferIds;

    if (selectedDeals.length === TN.length && state.currentPage > 1) {
      setState((prev) => ({ ...prev, currentPage: prev.currentPage - 1, permissibleDate: null }));
    } else {
      setState((prev) => ({ ...prev, permissibleDate: null }));
    }

    dispatch(transferDeals(data, viewReport, { pdf: filenamePdf, xlsx: filenameXlsx }));
    setAllChecked(false);
  };

  const printedTN = () => {
    if (selectedDeals.length) {
      if (selectedDeals.length !== 1) {
        setPopup((prev) => ({
          ...prev,
          isOpen: true,
          text: 'Выберите одну товарную накладную',
        }));
        return;
      }

      if (selectedDeals.length === 1 && !selectedDeals[0].checked) {
        setPopup((prev) => ({
          ...prev,
          isOpen: true,
          text: 'Необходимо выбрать товарную накладную',
        }));
        return;
      }

      const { transferId } = selectedDeals[0];
      const filename = 'exp_' + transferId + '_' + moment().format('DD.MM.YYYY') + '.xlsx';

      dispatch(
        getPrintedForm(
          {
            transferId,
          },
          filename,
          viewReports.INTERNAL_MOVEMENT_STORE,
        ),
      );
      checkBoxAfterOperation();
    }
  };

  const closeAlertModal = useCallback(() => {
    setPopup((prev) => ({ ...prev, isOpen: false }));
  }, []);

  const closeBasicAlert = () => setErrorModalState({...errorModalState, state: false})

  return (
    <>
      {commonError && <Message type="error" text={commonError} />}
      <div className="content-datatable">
        <div className="content-datatable-header sticky">
          <div className="content-datatable-header-left buttongroup-content">
            <div className="action-items">
              {store && (
                <>
                  {permissionsAccess("action.deal.status.transfer.totransfer") && (
                    <ActionButton
                      text="Вернуть на передачу"
                      func={openModal}
                      param={viewDocument.isToTransfer}
                    />
                  )}
                  {permissionsAccess("action.deal.sale.store") &&
                      <ActionButton
                        text="Отправить на продажу"
                        func={openModal}
                        param={viewDocument.isTransferdSaledStore}
                      />
                  }
                  {
                    permissionsAccess("action.deal.update.thing.estimated.value") &&
                      <ActionButton
                          text="Переоценка"
                          func={openModal}
                          param={viewDocument.isOverestimation}
                      />
                  }
                  {
                    permissionsAccess("action.deal.transfer.anotherstore") &&
                      <ActionButton
                          text="Передать в другой ломбард"
                          func={openModal}
                          param={viewDocument.isTransferAnotherStore}
                      />
                  }
                  {
                    permissionsAccess("action.deal.transfer.inventory") &&
                    <ActionButton
                        text="Сформировать инвентарь"
                        func={openModal}
                        param={viewDocument.isInventory}
                    />
                  }
                  {
                    permissionsAccess("action.report.generate.store") &&
                      <ActionButton
                          func={printedTN}
                          text="Печать"/>
                  }
                </>
              )}
              {saledStore && (
                <>
                  {permissionsAccess("action.deal.status.transfer.store") && (
                    <ActionButton
                      text={accessFeatures['deals.refund_things'] ? "Возврат невостребованного товара" : "Вернуть в Магазин"}
                      func={openModal}
                      param={viewDocument.isToStore}
                    />
                  )}
                </>
              )}
            </div>
          </div>
          <div className="content-datatable-header-right">
            <ShowItemsSelectPageCount
              options={pageOptions}
              change={onPageRangeChange}
              wrapClass={'padding-select'}
              statePageRange={state.pageRange}
            />
          </div>
        </div>
        <div className="content-datatable-content">
          {isLoading || userLoading ? (
            <Loader pageRange={state.pageRange} />
          ) : (
            <table className={isTabLoading ? 'table' : 'table hover'}>
              <thead>
                <tr className="tnStore-table-header">
                  <th scope="col">
                    <Checkbox
                      label="Номер"
                      id="checkboxContractSelectAll"
                      name="checkboxContractSelectAll"
                      onChange={handleAllContractCheck}
                      value={allChecked}
                    />
                  </th>
                  <th scope="col">
                    <p>
                      Тип <br />
                      документа
                    </p>
                  </th>
                  <th scope="col">
                    <p>Отправитель</p>
                  </th>
                  <th scope="col">
                    <p>Получатель</p>
                  </th>
                  <th scope="col">
                    <p>Дата</p>
                  </th>
                  <th scope="col">
                    <p>Пользователь</p>
                  </th>
                  <th scope="col"></th>
                </tr>
              </thead>
              <tbody>
                {notEmpty &&
                  TN.map((tn, ind) => {
                    return (
                      <Fragment key={tn.transferId}>
                        <tr>
                          <td>
                            <div className="table-cellcontent">
                              <Checkbox
                                id={tn.transferId + tn.transferDate}
                                name={tn.transferId}
                                onChange={handleTNCheck}
                                value={tn.checked}
                              />
                              <p>{tn.documentNumber}</p>
                            </div>
                          </td>
                          <td>
                            <p>ТН</p>
                          </td>
                          <td>
                            <p>{tn.sendCashboxName}</p>
                          </td>
                          <td>
                            <p>{tn.destCashboxName}</p>
                          </td>
                          <td>
                            <p>{moment(tn.transferDate).format('DD.MM.YYYY')}</p>
                          </td>
                          <td>
                            <p>{tn.userFullName}</p>
                          </td>
                          <td className={`tnStore-table-col-arrow${tn.isVisible ? '-up' : ''}`}>
                            <Arrow onClick={() => changeVisible(tn.transferId)} />
                          </td>
                        </tr>
                        <tr className={`tnStore-table-line${tn.isVisible ? '-visible' : ''}`}>
                          <td colSpan="7">
                            <TNStoreDetails
                              key={tn.transferId}
                              tn={tn}
                              transferId={tn.transferId}
                              isTabLoading={state.reqParamTN[ind].isTabLoading}
                              handleContractCheck={handleContractCheck}
                            />
                          </td>
                        </tr>
                      </Fragment>
                    );
                  })}
              </tbody>
            </table>
          )}
        </div>
      </div>
      <Pagination
        total={Math.ceil(total / state.pageRange)}
        current={state.currentPage}
        handlePageChange={handlePageChange}
      />
      <TransferSaledModal
        requestCurrentState={requestCurrentState}
        requestDealForTransfer={requestDealForTransfer}
        submitOverestimation={submitOverestimation}
        isOverestimationTransfer={isOverestimationTransfer}
        setIsOverestimationTransfer={setIsOverestimationTransfer}
        isOpen={state.isTransferdSaledStore}
        submitTransferSaledStore={submitTransferSaledStore}
        handleCloseModal={handleCloseModal}
        data={dealsForTransfer}
        modalError={modalError}
        isModalLoading={isModalLoading}
        viewDocument={viewDocument.isTransferdSaledStore}
        garage={false}
      />
      <ConfirmModal
        isOpen={state.isToTransfer || state.isToStore}
        handleClose={closeConfirm}
        handleAction={addToTransfer}
        bodyText={state.isToStore && accessFeatures['deals.refund_things'] ? <ReturnOfUnclaimedGoodsLayout data={selectedDeals}/> : ''}
        headerText={
          state.isToTransfer
            ? 'Вы хотите переместить на передачу?'
            : 'Вы хотите переместить в магазин?'
        }
        isNotTextContent={accessFeatures['deals.refund_things']}
      />
      <OverestimationModal
        isOpen={state.isOverestimation}
        handleCloseModal={handleCloseModal}
        data={dealsForTransfer}
        submitOverestimation={submitOverestimation}
        modalError={modalError}
        isModalLoading={isModalLoading}
        view={state.isOverestimation}
        tab={'STORE'}
      />
      <ToFormRegisterModal
        printedFormButton = {false}
        isOpen={state.isTransferAnotherStore}
        handleCloseModal={handleCloseModal}
        cashBoxInfo={cashBoxInfo}
        submitTransferDeals={submitTransferAnotherStore}
      />
      <ToFormWithdrawalInventoryModal
        isOpen={state.isInventory}
        handleCloseModal={handleCloseModal}
        view={viewDocument.isInventory}
        cashBoxInfo={cashBoxInfo}
        dealIds={null}
        submitTransferDeals={submitTransferInventory}
        permissibleDate={state.permissibleDate}
      />
      <AlertModal
        isOpen={popup.isOpen}
        handleClose={closeAlertModal}
        header={popup.header}
        text={popup.text}
      />
      <ModalInboxOperation
        isOpen={state.isInboxOperation}
        cashBoxName={userCashBox.label}
        type={'DEBIT'}
        onTransactionSubmit={addToTransferAndOnTransactionSubmit}
        closeModelCreateTransaction={()=>handleCloseModal('isInboxOperation')}
        transactionData={selectedDeals[0] && selectedDeals[0].deal?.deal[0]}
        refundThings={refundThings}
      />
      <BasicAlert onClose={() => closeBasicAlert()}
                  message={errorModalState.message}
                  isOpen={errorModalState.state}
                  isError={true}
      />
    </>
  );
});

export default TNStore;
